import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _577fbb78 = () => interopDefault(import('../../../pages/preview/activate.vue' /* webpackChunkName: "pages/preview/activate" */))
const _210112c0 = () => interopDefault(import('../../../pages/preview/disactivate.vue' /* webpackChunkName: "pages/preview/disactivate" */))
const _24ab89f2 = () => interopDefault(import('../../../pages/preview/preview.vue' /* webpackChunkName: "pages/preview/preview" */))
const _28ee8546 = () => interopDefault(import('../../../pages/_context/index.vue' /* webpackChunkName: "pages/_context/index" */))
const _046254fb = () => interopDefault(import('../../../pages/_context/account/index.vue' /* webpackChunkName: "pages/_context/account/index" */))
const _e2669ce4 = () => interopDefault(import('../../../pages/_context/account/addresses/index.vue' /* webpackChunkName: "pages/_context/account/addresses/index" */))
const _5d035d84 = () => interopDefault(import('../../../pages/_context/account/alerts.vue' /* webpackChunkName: "pages/_context/account/alerts" */))
const _63ec0fdc = () => interopDefault(import('../../../pages/_context/account/login.vue' /* webpackChunkName: "pages/_context/account/login" */))
const _404612b1 = () => interopDefault(import('../../../pages/_context/account/logout.vue' /* webpackChunkName: "pages/_context/account/logout" */))
const _5a82a80f = () => interopDefault(import('../../../pages/_context/account/orders/index.vue' /* webpackChunkName: "pages/_context/account/orders/index" */))
const _5935ead1 = () => interopDefault(import('../../../pages/_context/account/parrainage.vue' /* webpackChunkName: "pages/_context/account/parrainage" */))
const _6e991212 = () => interopDefault(import('../../../pages/_context/account/profile.vue' /* webpackChunkName: "pages/_context/account/profile" */))
const _64122800 = () => interopDefault(import('../../../pages/_context/account/reset-password.vue' /* webpackChunkName: "pages/_context/account/reset-password" */))
const _a0a4f640 = () => interopDefault(import('../../../pages/_context/pages/contact.vue' /* webpackChunkName: "pages/_context/pages/contact" */))
const _7030e6e4 = () => interopDefault(import('../../../pages/_context/pages/suivre-mon-colis.vue' /* webpackChunkName: "pages/_context/pages/suivre-mon-colis" */))
const _4a2a7711 = () => interopDefault(import('../../../pages/_context/pages/unsubscribe.vue' /* webpackChunkName: "pages/_context/pages/unsubscribe" */))
const _5d55bf76 = () => interopDefault(import('../../../pages/_context/account/addresses/_id.vue' /* webpackChunkName: "pages/_context/account/addresses/_id" */))
const _009b237a = () => interopDefault(import('../../../pages/_context/account/orders/_id/index.vue' /* webpackChunkName: "pages/_context/account/orders/_id/index" */))
const _64e978f3 = () => interopDefault(import('../../../pages/_context/questionnaires/typeform/_id.vue' /* webpackChunkName: "pages/_context/questionnaires/typeform/_id" */))
const _61793072 = () => interopDefault(import('../../../pages/_context/account/orders/_id/update-delivery-address.vue' /* webpackChunkName: "pages/_context/account/orders/_id/update-delivery-address" */))
const _3a16a969 = () => interopDefault(import('../../../pages/_context/blogs/_type/index.vue' /* webpackChunkName: "pages/_context/blogs/_type/index" */))
const _55364810 = () => interopDefault(import('../../../pages/_context/collections/_uid.vue' /* webpackChunkName: "pages/_context/collections/_uid" */))
const _4cc8aefe = () => interopDefault(import('../../../pages/_context/pages/_uid.vue' /* webpackChunkName: "pages/_context/pages/_uid" */))
const _3c576432 = () => interopDefault(import('../../../pages/_context/products/_uid.vue' /* webpackChunkName: "pages/_context/products/_uid" */))
const _529a3b5b = () => interopDefault(import('../../../pages/_context/questionnaires/_uid.vue' /* webpackChunkName: "pages/_context/questionnaires/_uid" */))
const _b0f0da6c = () => interopDefault(import('../../../pages/_context/blogs/_type/_uid.vue' /* webpackChunkName: "pages/_context/blogs/_type/_uid" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de-DE",
    component: _0547af50,
    name: "index___de-DE"
  }, {
    path: "/en-US",
    component: _0547af50,
    name: "index___en-US"
  }, {
    path: "/fr-FR",
    component: _0547af50,
    name: "index___fr-FR"
  }, {
    path: "/preview/activate",
    component: _577fbb78,
    name: "preview-activate___fr-FR___default"
  }, {
    path: "/preview/disactivate",
    component: _210112c0,
    name: "preview-disactivate___fr-FR___default"
  }, {
    path: "/preview/preview",
    component: _24ab89f2,
    name: "preview-preview"
  }, {
    path: "/de-DE/preview/activate",
    component: _577fbb78,
    name: "preview-activate___de-DE"
  }, {
    path: "/de-DE/preview/disactivate",
    component: _210112c0,
    name: "preview-disactivate___de-DE"
  }, {
    path: "/en-US/preview/activate",
    component: _577fbb78,
    name: "preview-activate___en-US"
  }, {
    path: "/en-US/preview/disactivate",
    component: _210112c0,
    name: "preview-disactivate___en-US"
  }, {
    path: "/fr-FR/preview/activate",
    component: _577fbb78,
    name: "preview-activate___fr-FR"
  }, {
    path: "/fr-FR/preview/disactivate",
    component: _210112c0,
    name: "preview-disactivate___fr-FR"
  }, {
    path: "/",
    component: _0547af50,
    name: "index___fr-FR___default"
  }, {
    path: "/de-DE/:context",
    component: _28ee8546,
    name: "context___de-DE"
  }, {
    path: "/en-US/:context",
    component: _28ee8546,
    name: "context___en-US"
  }, {
    path: "/fr-FR/:context",
    component: _28ee8546,
    name: "context___fr-FR"
  }, {
    path: "/de-DE/:context/account",
    component: _046254fb,
    name: "context-account___de-DE"
  }, {
    path: "/en-US/:context/account",
    component: _046254fb,
    name: "context-account___en-US"
  }, {
    path: "/fr-FR/:context/account",
    component: _046254fb,
    name: "context-account___fr-FR"
  }, {
    path: "/de-DE/:context/account/addresses",
    component: _e2669ce4,
    name: "context-account-addresses___de-DE"
  }, {
    path: "/de-DE/:context/account/alerts",
    component: _5d035d84,
    name: "context-account-alerts___de-DE"
  }, {
    path: "/de-DE/:context/account/login",
    component: _63ec0fdc,
    name: "context-account-login___de-DE"
  }, {
    path: "/de-DE/:context/account/logout",
    component: _404612b1,
    name: "context-account-logout___de-DE"
  }, {
    path: "/de-DE/:context/account/orders",
    component: _5a82a80f,
    name: "context-account-orders___de-DE"
  }, {
    path: "/de-DE/:context/account/parrainage",
    component: _5935ead1,
    name: "context-account-parrainage___de-DE"
  }, {
    path: "/de-DE/:context/account/profile",
    component: _6e991212,
    name: "context-account-profile___de-DE"
  }, {
    path: "/de-DE/:context/account/reset-password",
    component: _64122800,
    name: "context-account-reset-password___de-DE"
  }, {
    path: "/de-DE/:context/pages/contact",
    component: _a0a4f640,
    name: "context-pages-contact___de-DE"
  }, {
    path: "/de-DE/:context/pages/suivre-mon-colis",
    component: _7030e6e4,
    name: "context-pages-suivre-mon-colis___de-DE"
  }, {
    path: "/de-DE/:context/pages/unsubscribe",
    component: _4a2a7711,
    name: "context-pages-unsubscribe___de-DE"
  }, {
    path: "/en-US/:context/account/addresses",
    component: _e2669ce4,
    name: "context-account-addresses___en-US"
  }, {
    path: "/en-US/:context/account/alerts",
    component: _5d035d84,
    name: "context-account-alerts___en-US"
  }, {
    path: "/en-US/:context/account/login",
    component: _63ec0fdc,
    name: "context-account-login___en-US"
  }, {
    path: "/en-US/:context/account/logout",
    component: _404612b1,
    name: "context-account-logout___en-US"
  }, {
    path: "/en-US/:context/account/orders",
    component: _5a82a80f,
    name: "context-account-orders___en-US"
  }, {
    path: "/en-US/:context/account/parrainage",
    component: _5935ead1,
    name: "context-account-parrainage___en-US"
  }, {
    path: "/en-US/:context/account/profile",
    component: _6e991212,
    name: "context-account-profile___en-US"
  }, {
    path: "/en-US/:context/account/reset-password",
    component: _64122800,
    name: "context-account-reset-password___en-US"
  }, {
    path: "/en-US/:context/pages/contact",
    component: _a0a4f640,
    name: "context-pages-contact___en-US"
  }, {
    path: "/en-US/:context/pages/suivre-mon-colis",
    component: _7030e6e4,
    name: "context-pages-suivre-mon-colis___en-US"
  }, {
    path: "/en-US/:context/pages/unsubscribe",
    component: _4a2a7711,
    name: "context-pages-unsubscribe___en-US"
  }, {
    path: "/fr-FR/:context/account/addresses",
    component: _e2669ce4,
    name: "context-account-addresses___fr-FR"
  }, {
    path: "/fr-FR/:context/account/alerts",
    component: _5d035d84,
    name: "context-account-alerts___fr-FR"
  }, {
    path: "/fr-FR/:context/account/login",
    component: _63ec0fdc,
    name: "context-account-login___fr-FR"
  }, {
    path: "/fr-FR/:context/account/logout",
    component: _404612b1,
    name: "context-account-logout___fr-FR"
  }, {
    path: "/fr-FR/:context/account/orders",
    component: _5a82a80f,
    name: "context-account-orders___fr-FR"
  }, {
    path: "/fr-FR/:context/account/parrainage",
    component: _5935ead1,
    name: "context-account-parrainage___fr-FR"
  }, {
    path: "/fr-FR/:context/account/profile",
    component: _6e991212,
    name: "context-account-profile___fr-FR"
  }, {
    path: "/fr-FR/:context/account/reset-password",
    component: _64122800,
    name: "context-account-reset-password___fr-FR"
  }, {
    path: "/fr-FR/:context/pages/contact",
    component: _a0a4f640,
    name: "context-pages-contact___fr-FR"
  }, {
    path: "/fr-FR/:context/pages/suivre-mon-colis",
    component: _7030e6e4,
    name: "context-pages-suivre-mon-colis___fr-FR"
  }, {
    path: "/fr-FR/:context/pages/unsubscribe",
    component: _4a2a7711,
    name: "context-pages-unsubscribe___fr-FR"
  }, {
    path: "/de-DE/:context/account/addresses/:id",
    component: _5d55bf76,
    name: "context-account-addresses-id___de-DE"
  }, {
    path: "/de-DE/:context/account/orders/:id",
    component: _009b237a,
    name: "context-account-orders-id___de-DE"
  }, {
    path: "/de-DE/:context/questionnaires/typeform/:id?",
    component: _64e978f3,
    name: "context-questionnaires-typeform-id___de-DE"
  }, {
    path: "/en-US/:context/account/addresses/:id",
    component: _5d55bf76,
    name: "context-account-addresses-id___en-US"
  }, {
    path: "/en-US/:context/account/orders/:id",
    component: _009b237a,
    name: "context-account-orders-id___en-US"
  }, {
    path: "/en-US/:context/questionnaires/typeform/:id?",
    component: _64e978f3,
    name: "context-questionnaires-typeform-id___en-US"
  }, {
    path: "/fr-FR/:context/account/addresses/:id",
    component: _5d55bf76,
    name: "context-account-addresses-id___fr-FR"
  }, {
    path: "/fr-FR/:context/account/orders/:id",
    component: _009b237a,
    name: "context-account-orders-id___fr-FR"
  }, {
    path: "/fr-FR/:context/questionnaires/typeform/:id?",
    component: _64e978f3,
    name: "context-questionnaires-typeform-id___fr-FR"
  }, {
    path: "/de-DE/:context/account/orders/:id/update-delivery-address",
    component: _61793072,
    name: "context-account-orders-id-update-delivery-address___de-DE"
  }, {
    path: "/en-US/:context/account/orders/:id/update-delivery-address",
    component: _61793072,
    name: "context-account-orders-id-update-delivery-address___en-US"
  }, {
    path: "/fr-FR/:context/account/orders/:id/update-delivery-address",
    component: _61793072,
    name: "context-account-orders-id-update-delivery-address___fr-FR"
  }, {
    path: "/de-DE/:context/blogs/:type",
    component: _3a16a969,
    name: "context-blogs-type___de-DE"
  }, {
    path: "/de-DE/:context/collections/:uid?",
    component: _55364810,
    name: "context-collections-uid___de-DE"
  }, {
    path: "/de-DE/:context/pages/:uid?",
    component: _4cc8aefe,
    name: "context-pages-uid___de-DE"
  }, {
    path: "/de-DE/:context/products/:uid?",
    component: _3c576432,
    name: "context-products-uid___de-DE"
  }, {
    path: "/de-DE/:context/questionnaires/:uid?",
    component: _529a3b5b,
    name: "context-questionnaires-uid___de-DE"
  }, {
    path: "/en-US/:context/blogs/:type",
    component: _3a16a969,
    name: "context-blogs-type___en-US"
  }, {
    path: "/en-US/:context/collections/:uid?",
    component: _55364810,
    name: "context-collections-uid___en-US"
  }, {
    path: "/en-US/:context/pages/:uid?",
    component: _4cc8aefe,
    name: "context-pages-uid___en-US"
  }, {
    path: "/en-US/:context/products/:uid?",
    component: _3c576432,
    name: "context-products-uid___en-US"
  }, {
    path: "/en-US/:context/questionnaires/:uid?",
    component: _529a3b5b,
    name: "context-questionnaires-uid___en-US"
  }, {
    path: "/fr-FR/:context/blogs/:type",
    component: _3a16a969,
    name: "context-blogs-type___fr-FR"
  }, {
    path: "/fr-FR/:context/collections/:uid?",
    component: _55364810,
    name: "context-collections-uid___fr-FR"
  }, {
    path: "/fr-FR/:context/pages/:uid?",
    component: _4cc8aefe,
    name: "context-pages-uid___fr-FR"
  }, {
    path: "/fr-FR/:context/products/:uid?",
    component: _3c576432,
    name: "context-products-uid___fr-FR"
  }, {
    path: "/fr-FR/:context/questionnaires/:uid?",
    component: _529a3b5b,
    name: "context-questionnaires-uid___fr-FR"
  }, {
    path: "/de-DE/:context/blogs/:type?/:uid",
    component: _b0f0da6c,
    name: "context-blogs-type-uid___de-DE"
  }, {
    path: "/en-US/:context/blogs/:type?/:uid",
    component: _b0f0da6c,
    name: "context-blogs-type-uid___en-US"
  }, {
    path: "/fr-FR/:context/blogs/:type?/:uid",
    component: _b0f0da6c,
    name: "context-blogs-type-uid___fr-FR"
  }, {
    path: "/:context",
    component: _28ee8546,
    name: "context___fr-FR___default"
  }, {
    path: "/:context/account",
    component: _046254fb,
    name: "context-account___fr-FR___default"
  }, {
    path: "/:context/account/addresses",
    component: _e2669ce4,
    name: "context-account-addresses___fr-FR___default"
  }, {
    path: "/:context/account/alerts",
    component: _5d035d84,
    name: "context-account-alerts___fr-FR___default"
  }, {
    path: "/:context/account/login",
    component: _63ec0fdc,
    name: "context-account-login___fr-FR___default"
  }, {
    path: "/:context/account/logout",
    component: _404612b1,
    name: "context-account-logout___fr-FR___default"
  }, {
    path: "/:context/account/orders",
    component: _5a82a80f,
    name: "context-account-orders___fr-FR___default"
  }, {
    path: "/:context/account/parrainage",
    component: _5935ead1,
    name: "context-account-parrainage___fr-FR___default"
  }, {
    path: "/:context/account/profile",
    component: _6e991212,
    name: "context-account-profile___fr-FR___default"
  }, {
    path: "/:context/account/reset-password",
    component: _64122800,
    name: "context-account-reset-password___fr-FR___default"
  }, {
    path: "/:context/pages/contact",
    component: _a0a4f640,
    name: "context-pages-contact___fr-FR___default"
  }, {
    path: "/:context/pages/suivre-mon-colis",
    component: _7030e6e4,
    name: "context-pages-suivre-mon-colis___fr-FR___default"
  }, {
    path: "/:context/pages/unsubscribe",
    component: _4a2a7711,
    name: "context-pages-unsubscribe___fr-FR___default"
  }, {
    path: "/:context/account/addresses/:id",
    component: _5d55bf76,
    name: "context-account-addresses-id___fr-FR___default"
  }, {
    path: "/:context/account/orders/:id",
    component: _009b237a,
    name: "context-account-orders-id___fr-FR___default"
  }, {
    path: "/:context/questionnaires/typeform/:id?",
    component: _64e978f3,
    name: "context-questionnaires-typeform-id___fr-FR___default"
  }, {
    path: "/:context/account/orders/:id/update-delivery-address",
    component: _61793072,
    name: "context-account-orders-id-update-delivery-address___fr-FR___default"
  }, {
    path: "/:context/blogs/:type",
    component: _3a16a969,
    name: "context-blogs-type___fr-FR___default"
  }, {
    path: "/:context/collections/:uid?",
    component: _55364810,
    name: "context-collections-uid___fr-FR___default"
  }, {
    path: "/:context/pages/:uid?",
    component: _4cc8aefe,
    name: "context-pages-uid___fr-FR___default"
  }, {
    path: "/:context/products/:uid?",
    component: _3c576432,
    name: "context-products-uid___fr-FR___default"
  }, {
    path: "/:context/questionnaires/:uid?",
    component: _529a3b5b,
    name: "context-questionnaires-uid___fr-FR___default"
  }, {
    path: "/:context/blogs/:type?/:uid",
    component: _b0f0da6c,
    name: "context-blogs-type-uid___fr-FR___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
